export default __webpack_public_path__ + "static/media/esim_logo.2c43cd76.png";